"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _src = _interopRequireDefault(require("../src"));

require("datatables.net-bs4");

require("datatables.net-responsive/js/dataTables.responsive.js");

require("datatables.net-responsive-bs4/js/responsive.bootstrap4.js");

require("datatables.net-select-bs4/css/select.bootstrap4.min.css");

require("datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css");

require("datatables.net-responsive-bs4/css/responsive.bootstrap4.css");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// this demonstrate with buttons and responsive master/details row
var _default = {
  name: 'TrainOperationsDepartures',
  components: {
    VdtnetTable: _src["default"]
  },
  data: function data() {
    var vm = this;
    return {
      //fields: this.$parent.fields,
      options: {
        ajax: {
          url: this.$parent.url,
          dataSrc: 'sortides'
        },
        buttons: [],
        responsive: true,
        processing: true,
        searching: false,
        searchDelay: 1500,
        destroy: true,
        ordering: false,
        lengthChange: false,
        serverSide: false,
        fixedHeader: true,
        saveState: true,
        info: false,
        paging: false
      },
      fields: {
        datasortida: {
          label: 'Surt a'
        },
        numtren: {
          label: 'Num tren'
        },
        nomestacidesti: {
          label: 'Estació destí'
        },
        estatescala: {
          label: 'Estat operatiu'
        },
        codiestaciodesti: {
          label: 'Codi E'
        },
        // nomterminaldesti: {label: 'Nom terminal'},
        numescala: {
          label: 'Número d’Escala'
        },
        operadorferroviari: {
          label: 'Operador ferrovirari'
        },
        operadorlogistic: {
          label: 'Operador logístic'
        }
      },
      quickSearch: '',
      details: {}
    };
  },
  methods: {}
};
exports["default"] = _default;